const defaultColDef = {
    sortable: true, 
    resizable: true,
    filter: true
};

export default defaultColDef;